import { setLinkForResults } from './utils';

import { AxiosInstance, CabinetPoints, ICabinetService } from './types';

const getProgramsData = (api: AxiosInstance) => ({
  getPrograms: async (id: string): Promise<any> => {
    try {
      const { data } = await api.get(CabinetPoints.GET_PROGRAMS, {
        params: { kid_id: id },
      });
      return setLinkForResults(data.data);
    } catch (error) {
      throw new Error(
        'Ошибка загрузки данных, пожалуйста, повторите попытку позже!',
      );
    }
  },
});

const cabinetService = (api: AxiosInstance): ICabinetService => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getProgramsData(api),
  };
};

export default cabinetService;



// WEBPACK FOOTER //
// ./src/services/cabinet/cabinetService.ts